import { useMutation } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface IPaycorSettings {
  export_paygrids: boolean;
  // use_labor_codes: boolean;
}

const savePaycorSettings = (postData: IPaycorSettings) => {
  return http().post(endpoints.integrations.paycor.settings, postData);
};

export function useSavePaycorSettings() {
  return useMutation({ mutationFn: savePaycorSettings });
}
